<template>
  <main class="main main--search-services search-services">
    <div>
      <div class="group group--last group--indent group--indent--both" ref="main">
        <h1 
          :style="{ 'color': org.custom_color1 == null ? '': org.custom_color1 }"
          class="h1 mb0">Find services</h1>
        <p class="p mt0">Search for services that are appropriate to your need and that are convenient for you.</p>
        <div v-for="(section, key) in serviceLinks" :key="key">
          <section v-if="section.subcategories.length > 0">
            <h3 
              :style="{ 'color': org.custom_color1 == null ? '': org.custom_color1 }"
              class="h2">{{ section.name }}</h3>
            <ul class="ml">
              <module-service-item
                v-for="(providerService, key) in section.subcategories"
                :key="key"
                :arrow="false"
                :service="providerService"
              />
            </ul>
          </section>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
// Vuex
import { mapGetters } from 'vuex';

// Import
import ModuleServiceItem from 'components/ServiceItem';

// Export
export default {
  name: 'services-search',

  components: {
    ModuleServiceItem,
  },

  computed: {
    ...mapGetters('app', ['org', 'serviceLinks']),
  },

  // Lifecyle
  created() {
    if(!this.serviceLinks) {
      this.$router.push({ name: 'home' });
    }
  },
};
</script>



// WEBPACK FOOTER //
// ServicesSearch.vue?13e5c872